import * as React from 'react';

import {ClipPath, Defs, G, Path, Rect} from 'react-native-svg';

import {Icon} from '.';
import {IconProps} from './type';

const ReScanIcon: React.FC<IconProps> = props => {
  return (
    <Icon {...props}>
      <Path fill="#1E1E1E" d="M0 0h16v17H0z" />
      <G clipPath="url(#a)">
        <Rect x={-283} y={-327} fill="#fff" rx={10} />
        <Rect width={66} height={19} x={-5} y={-1} rx={9.5} />
        <Path
          fill="#fff"
          d="M8 11.833c-.811 0-1.52-.252-2.125-.758a3.269 3.269 0 0 1-1.142-1.908h1.034c.144.489.42.889.825 1.2A2.25 2.25 0 0 0 8 10.833c.644 0 1.194-.227 1.65-.683a2.248 2.248 0 0 0 .683-1.65c0-.644-.227-1.194-.683-1.65A2.248 2.248 0 0 0 8 6.167a2.28 2.28 0 0 0-1.633.667h.966v1H4.667V5.166h1v.95c.3-.29.65-.52 1.05-.692.4-.172.827-.258 1.283-.258.922 0 1.708.325 2.359.975.65.65.975 1.436.974 2.358 0 .922-.325 1.708-.975 2.359-.65.65-1.436.975-2.358.974ZM3.333 14.5c-.366 0-.68-.13-.941-.391A1.286 1.286 0 0 1 2 13.167V10.5h1.333v2.667H6V14.5H3.333Zm6.667 0v-1.333h2.667V10.5H14v2.667c0 .366-.13.68-.391.942-.261.261-.575.391-.942.391H10Zm-8-8V3.833c0-.366.13-.68.392-.941.261-.26.575-.392.941-.392H6v1.333H3.333V6.5H2Zm10.667 0V3.833H10V2.5h2.667c.366 0 .68.13.942.392.261.261.391.575.391.941V6.5h-1.333Z"
        />
      </G>
      <Defs>
        <ClipPath id="a">
          <Rect
            width={375}
            height={667}
            x={-283}
            y={-327}
            fill="#fff"
            rx={10}
          />
        </ClipPath>
      </Defs>
    </Icon>
  );
};

export default ReScanIcon;
